import { useState, useCallback } from 'react';
import { useRouter } from '@repo/ui/hooks/use-router';
import { Logger } from '@repo/ui/lib/logger/index';
import { useDuplicateInventaire } from '../../../hooks';
import { useInventaireErrorHandler } from '@repo/ui/hooks/api/inventaires/use-inventaire-error-handler';

interface UseDuplicateDialogProps {
  inventaireId: number;
}

export function useDuplicateDialog({ inventaireId }: UseDuplicateDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const duplicateMutation = useDuplicateInventaire();
  const { handleError } = useInventaireErrorHandler();

  const handleDuplicate = useCallback(async () => {
    if (!inventaireId) return;

    try {
      const result = await duplicateMutation.mutateAsync({
        id: inventaireId,
        data: { copy_arbre_epaysage: true, creation_source: 'WEB' },
      });

      if (result.data?.id) {
        setIsOpen(false);
        router.push(`/admin/inventaires/${result.data.id}/arbre/details`);
      }
    } catch (error) {
      Logger.error('Erreur lors de la duplication:', error);
      // Gérer les erreurs de limite d'usage avec le toast
      handleError(error);
      // Ne pas fermer le dialog en cas d'erreur pour que l'utilisateur puisse voir l'erreur
    }
  }, [inventaireId, duplicateMutation, router, handleError]);

  const openDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);
  }, []);

  return {
    isOpen,
    openDialog,
    handleOpenChange,
    handleDuplicate,
    isPending: duplicateMutation.isPending,
  };
}

